import {
  getIndicators,
  getSupportedIndicatorVars,
  updateIndicator as apiUpdateIndicator,
  defineIndicator as apiDefineIndicator,
  deleteIndicator as apiDeleteIndicator
} from "Api";
import * as actions from "Actions";
import { selectCurrentOrganization } from "../../selectors";

export const fetchIndicators = () => {
  return (dispatch, getState) => {
    const { uen } = selectCurrentOrganization(getState());

    dispatch(
      actions.fetchIndicators(
        getIndicators({ uen }).then(res => {
          const data = res.data;
          return data;
        })
      )
    );
  };
};

export const fetchSupportedIndicatorVars = (ownerUen = null) => {
  return (dispatch, getState) => {
    let fiduciaryUen = ownerUen;
    if (!ownerUen) {
      const { uen } = selectCurrentOrganization(getState());
      fiduciaryUen = uen;
    }

    const { token } = getState().auth;

    dispatch(
      actions.fetchSupportedIndicatorVars(
        getSupportedIndicatorVars({ fiduciaryUen, token }).then(res => {
          const data = res.data;
          return data;
        })
      )
    );
  };
};

export const updateIndicator = indicator => {
  return (dispatch, getState) => {
    const { uen } = selectCurrentOrganization(getState());
    const { id, labels, formula, unit } = indicator;
    return dispatch(
      actions.updateIndicator(
        apiUpdateIndicator({ uen, id, labels, formula, unit })
      )
    );
  };
};

export const defineIndicator = indicator => {
  return (dispatch, getState) => {
    const { uen } = selectCurrentOrganization(getState());
    const { labels, formula, unit } = indicator;
    return dispatch(
      actions.defineIndicator(
        apiDefineIndicator({ uen, labels, formula, unit })
      )
    );
  };
};

export const deleteIndicator = indicator => {
  return (dispatch, getState) => {
    const { uen } = selectCurrentOrganization(getState());
    const { id } = indicator;
    return dispatch(actions.deleteIndicator(apiDeleteIndicator({ uen, id })));
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/indicator.js